"use strict";
import { jsx, jsxs } from "react/jsx-runtime";
export const visibilityOffIcon = () => {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      className: "v2__icon document-browser__visibility-off",
      height: "16px",
      width: "16px",
      viewBox: "0 0 16 16",
      role: "img",
      "aria-label": "Visiblity Off",
      children: /* @__PURE__ */ jsxs("g", { fill: "none", fillRule: "evenodd", strokeWidth: "1", children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M10.9735,7.7629 C10.9735,9.4199 9.6305,10.7629 7.9735,10.7629 C6.3165,10.7629 4.9735,9.4199 4.9735,7.7629 C4.9735,6.1059 6.3165,4.7629 7.9735,4.7629 C9.6305,4.7629 10.9735,6.1059 10.9735,7.7629",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx(
          "line",
          {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "2",
            x1: "2.2001",
            x2: "14.3881",
            y1: "13.6999",
            y2: "1.9999"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M7.9989,12.2619 C10.5499,12.3079 13.1379,10.3869 14.7339,8.5039 C15.0889,8.0819 15.0889,7.4419 14.7339,7.0199 C14.4729,6.7119 14.1869,6.4059 13.8799,6.1079 C13.2699,5.5139 12.5789,4.9549 11.8409,4.4929",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "2"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M7.9989,3.2638 C5.4909,3.2188 2.8969,5.0968 1.2659,7.0198 C0.9119,7.4418 0.9119,8.0818 1.2659,8.5038 C2.1499,9.5468 3.3379,10.6018 4.6559,11.3278",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "2"
          }
        )
      ] })
    }
  );
};
export const visibilityIcon = () => {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      className: "v2__icon document-browser__visibility-off",
      height: "16px",
      width: "16px",
      viewBox: "0 0 16 16",
      role: "img",
      "aria-label": "Visiblity On",
      children: /* @__PURE__ */ jsxs(
        "g",
        {
          fill: "none",
          fillRule: "evenodd",
          stroke: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1",
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                d: "M8,3.5 C5.49179157,3.45466472 2.89678208,5.33463561 1.2659177,7.25805135 C0.911360766,7.67980458 0.911360766,8.3203617 1.2659177,8.74211493 C2.86131498,10.6248623 5,12.5 8,12.5 C11,12.5 13.1374406,10.6248623 14.7340823,8.74211493 C15.0886392,8.3203617 15.0886392,7.67980458 14.7340823,7.25805135 C13.1013512,5.33463561 10.5082084,3.45466472 8,3.5 Z",
                stroke: "currentColor",
                strokeWidth: "2"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                d: "M10,8.00053337 C9.99970518,9.10503337 9.10414435,10.0001963 7.99964436,10 C6.89514437,9.99980363 5.99990185,9.10432235 6,7.9998223 C6.00009815,6.89532226 6.89549981,6 8,6 C8.53056859,5.99985847 9.03943951,6.2105999 9.41455828,6.58581872 C9.78967704,6.96103753 10.0002828,7.46996464 10,8.00053337 L10,8.00053337 Z",
                stroke: "currentColor",
                strokeWidth: "2"
              }
            )
          ]
        }
      )
    }
  );
};
